<div class="wrapper">
  <label class="toggle">
    <input
      type="checkbox"
      [id]="name"
      [name]="name"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onToggle($event)"
    />
    <span class="track">
      <span class="thumb"></span>
    </span>
  </label>
  <label for="{{ name }}" class="toggle-label">
    {{ label }}
  </label>
</div>
